import { createContext, useContext } from 'react';

export const SeedContext = createContext<number>(Math.random());

const useSeed = () => useContext(SeedContext);

export default useSeed;
